// extracted by mini-css-extract-plugin
export var heroImage = "_ma-1";
export var modal = "_ma-0";